<script>
export default {
  props: {
    applyDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['clear', 'today', 'apply'],
};
</script>

<template>
  <div class="flex items-center justify-between gap-2 pt-4">
    <button type="button" class="btn-grey !h-10 !px-3 font-medium !text-primary" @click="$emit('clear', $event)">
      {{ $primevue.config.locale.clear }}
    </button>
    <div class="flex items-center gap-2">
      <button type="button" class="btn-secondary-light !h-10 !px-3 font-medium" @click="$emit('today', $event)">
        {{ $primevue.config.locale.today }}
      </button>
      <button
        type="button"
        class="btn-primary !h-10 !px-3 font-medium"
        :disabled="applyDisabled"
        @click="$emit('apply', $event)">
        {{ $t('apply') }}
      </button>
    </div>
  </div>
</template>
